import fetchWithTimeout from '@picsart/rc/fetchWithTimeout';

import { PA_HEADERS, RATIO_CARDS_URL } from 'configs/constants';
import { ICardsData } from 'types';

const fetchRatioCards = async () => {
  const data = await fetchWithTimeout(RATIO_CARDS_URL, {
    headers: { ...PA_HEADERS },
  });
  const finalData = await data.json();
  return finalData.response.ratio_card.data.map((item: ICardsData) => ({ ...item, name: item.title }));
};

export default fetchRatioCards;
